/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Alert from "./Alert";
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from '@fortawesome/free-solid-svg-icons'
import FormInput from "./FormInput";
import Globals from "../shared/Globals";
import { SidebarGlobal } from "./Sidebar";

class ExaminationList extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {
                accountID: Number(this.props.params.accountID ?? 0)
            },
            loaded: false,
            loading: false,
            list: []
        };
        this.load = this.load.bind(this);
        this.search = this.search.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group d-none">
            <Link to="/examination/new" className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> Quick Create</Link>
        </div></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        this.setState({ loading: true });
        this.loading = true;
        qreq.post('/api/patient/list', this.state.query, j => {
            if (j.list) {
                this.setState({ list: j.list });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
            this.loading = false;
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
            this.loading = false;
        });
    }

    search(e) {
        if (e)
            e.preventDefault();

        if (this.loading) {
            setTimeout(() => this.search(), 100);
            return;
        }

        if (this.searchTimeout)
            clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 1000);
    }

    getRiskColor(risk) {
        if(risk === 'acute')
            return 'bg-warning';
        else if(risk === 'chronic')
            return 'bg-danger';
        else if(!risk)
            return 'bg-secondary';
        else
            return 'bg-dark';
    }

    render() {
        const header = (<h1>Examinations</h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        var nowIdent = Globals.toDateOnlyString(new Date());

        return <div className="container-fluid pb-3">
            {header}
            <form onSubmit={this.search}>
                <div className="mb-3">
                    <FormInput model={this.state.query} name="search" label="Search for a patient..." labelAsPlaceholder onChange={() => { this.search(); }} />
                </div>
            </form>
            {this.state.view === 'table' ?
            <DataTable columns={[
                {
                    name: 'new', style: { width: '200px' }, valueFunc: obj => {
                        if(obj.lastExamDateIdent === nowIdent)
                            return <button type="button" className="btn btn-success" onClick={() => this.props.navigate('/examination/view/' + obj.id)}>View/Edit Examination</button>;
                        else if(obj.examinationCount === 0)
                            return <button type="button" className="btn btn-info" onClick={() => this.props.navigate('/examination/view/' + obj.id)}>Initial Assessment</button>;
                        else
                            return <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/examination/view/' + obj.id)}>New Examination</button>;
                    }
                },
                { name: 'name', title: 'Patient', link: '/examination/view/:id', tooltip: 'View Examinations' },
                { name: 'latestRiskTab', title: 'Risk Score', style: {textTransform: 'capitalize'} },
                { name: 'lastExamDateIdent', title: 'Last Examination', valueFunc: obj => {
                    if(obj.lastExamDateIdent)
                        return obj.lastExamDateIdent;
                    else
                        return 'Never';
                } },
                { name: 'examinationCount', title: 'Examined', valueFunc: obj => { return String(obj.examinationCount); } }
            ]} data={this.state.list} loading={this.state.loading} /> : <div className="mt-2">
                {this.state.list.map(i => <Link key={i.id} to={'/examination/view/' + i.id} role="button" className="d-block rounded data-link drop-shadow bg-light p-3 mt-2">
                    <h5>{i.firstName} {i.lastName}</h5>
                    <div>DoB: <strong>{i.birthDate ?? 'Unknown'}</strong></div>
                    <i className={'d-block ' + (i.lastExamDateIdent === nowIdent ? 'text-success' : 'text-muted')}>Last Examined: {i.lastExamDateIdent === nowIdent ? 'Today' : (i.lastExamDateIdent ?? 'Never')}</i>
                    <small className={'badge text-capitalize ' + this.getRiskColor(i.latestRiskTab)}>{i.latestRiskTab ?? 'Not Classified'}</small>
                </Link>)}
            </div>}
        </div>;
    }
}

export default withParamsAndNavigate(ExaminationList);